import React from 'react'
import PropTypes from 'prop-types'
import classes from './styles.module.scss'
import messages from './messages'
import { injectIntl } from 'react-intl'
import { Picker, List, InputItem } from 'antd-mobile'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { getCountryCallingCode } from 'react-phone-number-input/mobile'
import { connect } from 'react-redux'

class PhoneInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  changeCountry = () => {
    this.props.form.resetFields(['tel'])
  }

  changeTel = (value) => {
    const { name, form } = this.props
    const callingCode = getCountryCallingCode(form.getFieldValue('country'))
    const data = {}
    data[name] = `+${callingCode}-${value}`
    form.setFieldsValue(data)
  }

  render() {
    const {
      intl,
      form,
      name,
      placeholder = intl.formatMessage(messages['input.placeholder']),
      initialValue,
      allowedCountries,
    } = this.props
    var initialCountry = 'AE'
    var tel = ''
    if (initialValue) {
      const phoneNumber = parsePhoneNumberFromString(initialValue)
      if (phoneNumber) {
        tel = phoneNumber.formatNational()
        initialCountry = phoneNumber.country
      }
    }

    const countryData = allowedCountries.map(code => ({
      value: code.countryCode,
      label: (
        <div>
          <span>
            {code.phonePrefix} {code.countryFullName}
          </span>
        </div>
      )
    }))

    return (
      <React.Fragment>
        {form.getFieldDecorator(name, {
          rules: [
            {
              required: true,
            },
          ],
        })(<InputItem className='dn' />)}
        {form.getFieldDecorator('country', {
          initialValue: [initialCountry],
          onChange: this.changeCountry,
          rules: [
            {
              required: true,
            },
          ],
        })(
          <Picker
            data={[countryData]}
            title={intl.formatMessage(messages['picker.title'])}
            cols={1}
            cascade={false}
          >
            <List.Item
              arrow='horizontal'
              className={`am-input-item ${classes.countrySelecter}`}
            />
          </Picker>
        )}
        {form.getFieldDecorator('tel', {
          initialValue: tel,
          onChange: this.changeTel,
          normalize: (value, prev) => {
            const country = form.getFieldValue('country')[0]
            const phoneNumber = parsePhoneNumberFromString(value, country)
            if (phoneNumber) {
              return phoneNumber.formatNational()
            }
            return value
          },
          rules: [
            {
              required: true,
            },
          ],
        })(
          <InputItem
            className={classes.amountInput}
            maxLength={13}
            type='number'
            placeholder={placeholder}
          />
        )}
      </React.Fragment>
    )
  }
}

PhoneInput.propTypes = {
  form: PropTypes.object.isRequired,
  allowedCountries: PropTypes.array.isRequired,
}

const mapStateToProps = (state) => ({
  allowedCountries: state.siteConfig.allowedCountries.list, // Assuming list is an array of objects
})

export default connect(mapStateToProps)(injectIntl(PhoneInput))
